import { env } from '@/config/env';
import { createAuthClient } from './auth-client';
import { createHttpClient } from './http-client';
import { createSessionRefresher } from './session-refresher';
import { createSessionStore } from './session-store';

/** Store de sessão da aplicação (em memória). */
export const sessionStore = createSessionStore();
/** Cliente de auth sem interceptors. */
export const authClient = createAuthClient(env.VITE_API_URL);
/** Refresh single-flight compartilhado por interceptors, loaders e boot. */
export const sessionRefresher = createSessionRefresher(authClient, sessionStore);
/** Cliente HTTP da aplicação. */
export const httpClient = createHttpClient({
  baseURL: env.VITE_API_URL,
  store: sessionStore,
  refresher: sessionRefresher,
});
